import { useContext } from 'react';
import { AIDrawerContext } from '../providers/AIDrawerContext';

export function useAIDrawer() {
  const ctx = useContext(AIDrawerContext);
  if (!ctx) {
    throw new Error('useAIDrawer must be used within AIDrawerProvider');
  }
  return ctx;
}
